import React from "react";
// Keep ImageList and ImageListItem imports from the original
import { Box, Typography, Chip, useTheme, useMediaQuery, ImageList, ImageListItem, Grid, Container,Divider } from "@mui/material";
import { useParams } from "react-router-dom";

// Original commented-out imports (kept as they were)
// import UserAnalytics from "../Components/UserAnalytics.component";
// import UserTrades from "../Components/UserTrades.component";
// import UserHoldings from "../Components/UserHoldings.component";
// import TradingViewChart from "../Components/TradeViewChart";

// Original component imports
import TokenOverview from "../Components/Token/TokenOverview.component";
import TokenTrades from "../Components/Token/TokenTrades.component";
import TokenPriceHistory from "../Components/Token/TokenPriceHistory.component";
import TokenAnalytics from "../Components/Token/TokenAnalytics.component";
import TokenHeader from "../Components/Token/TokenHeader.component";
import BubbleChartComponent from "../Components/Token/TokenBubbleChart.component"; // Keep if needed later
import TokenCreator from "../Components/Token/TokenCreator.component";
import QuickBuy from "../Components/Common/QuickBuy.component";
import TokenTabs from "../Components/Token/TokenTabs.component";
import TokenTrade from "../Components/Token/TokenTrade.component";
import TokenRisk from "../Components/Token/TokenRisk.component";

const TokenPage = () => {
  const { token } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // detects small devices

  // Helper function for the chip click
  const handleChipClick = () => {
    window.open(`https://odin.fun/token/${ token }`, "_blank");
  };

  // Basic check if token exists (optional but recommended)
  if (!token) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="error">
          Token ID not found in URL.
        </Typography>
      </Box>
    );
  }
  // return <BubbleChartComponent tokenId={token} />

  return (<Box sx={{ background: theme.palette.background.default, minHeight: '100vh', py: 4 }}>
    <Container maxWidth="xl">
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12} sm={9}>
          <TokenOverview tokenId={token} />
          <TokenPriceHistory tokenId={token} />
          <TokenTabs tokenId={token} />
        </Grid>
        <Grid item xs={12} sm={3}>

          <TokenRisk tokenId={token} />
          <Divider sx={{ my: 2 }} />
          <TokenCreator tokenId={token} />
          <TokenTrade tokenId={token} />
        </Grid>
        {/* <Grid item xs={12} sm={8}>
          <TokenPriceHistory tokenId={token} />
          <TokenTabs tokenId={token} />
        </Grid> */}

      </Grid>
    </Container>

  </Box>);


  return (
    // Original outer Box structure
    <Box sx={{ width: "100%", margin: "auto" }}>
      <Grid container spacing={2} sx={{ padding: 2 }}>\
        <Grid item xs={12} sm={9}>
          <Box sx={{ background: "red" }}>

          </Box>
          {/* <TokenOverview tokenId={token} />
          <TokenPriceHistory tokenId={token} />
          <TokenTabs tokenId={token} /> */}
        </Grid>
        <Grid item xs={12} sm={3}>
          <Box sx={{ background: "red" }}>
            hello
          </Box>
          {/* <TokenCreator tokenId={token} /> */}
        </Grid>
        {/* <Grid item xs={12} sm={8}>
          <TokenPriceHistory tokenId={token} />
          <TokenTabs tokenId={token} />
        </Grid> */}

      </Grid>
    </Box >
  );


  return (
    // Original outer Box structure
    <Box sx={{ width: "100%", margin: "auto" }}>

      {/* --- MODIFIED HEADER SECTION --- */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row', // Stack vertically on mobile
          alignItems: 'center', // Center items vertically or horizontally depending on direction
          justifyContent: 'center', // Distribute space nicely
          flexWrap: 'wrap', // Allow wrapping if space is tight
          gap: 2, // Add gap between flex items
          p: 1, // Add some padding
          width: '100%',
        }}
      >
        {/* Group Header and Chip */}
        <Box sx={{ textAlign: 'center', mb: isMobile ? 2 : 0 }}> {/* Add margin bottom on mobile */}
          <TokenOverview tokenId={token} />

        </Box>

      </Box>
      {/* --- END OF MODIFIED HEADER SECTION --- */}
      <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: "center", mb: 2, width: '100%' }}>
        <QuickBuy tokenId={token} />
      </Box>

      {/* --- ORIGINAL IMAGELIST SECTION (Unchanged from your initial code) --- */}
      <ImageList variant="masonry" cols={isMobile ? 1 : 2} gap={8} sx={{ padding: 2 }}>
        <ImageListItem>
          {/* Original empty Typography - kept as requested */}
          <Typography variant="h6" align="center">

          </Typography>
          {/* Original commented out TradingViewChart */}
          {/* <TradingViewChart id={token} /> */}
        </ImageListItem>
        <ImageListItem>
          <TokenCreator tokenId={token} />
        </ImageListItem>
        <ImageListItem>
          <TokenPriceHistory tokenId={token} />
        </ImageListItem>
        <ImageListItem>
          {/* Original potentially duplicate or alternative placement */}
          {/* <TokenPriceHistory tokenId={token} /> */}
          <TokenTrades tokenId={token} />
        </ImageListItem>
        <ImageListItem>
          <TokenAnalytics tokenId={token} />
        </ImageListItem>
        {/* Original commented out BubbleChart */}
        <ImageListItem>
          <BubbleChartComponent tokenId={token} />
        </ImageListItem>

        {/* Original commented out placeholders */}
        {/* <Trades tokenId={tokenId} />
        <PriceHistory tokenId={tokenId} />
        <Analytics tokenId={tokenId} /> */}
      </ImageList>;
      {/* --- END OF ORIGINAL IMAGELIST SECTION --- */}
    </Box >
  );
};

export default TokenPage;